import { forwardRef } from "react";
import styled from "styled-components";
import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";
import type { TCodeBlockElement } from "@platejs/utils";

import { CodeBlockCombobox } from "./CodeBlockCombobox";

export const CodeBlockElement = forwardRef<
	HTMLDivElement,
	PlateElementProps<TCodeBlockElement>
>((props, ref) => {
	return (
		<PlateElement
			ref={ref}
			style={{
				position: "relative",
				paddingBottom: "0.25rem",
				paddingTop: "0.25rem",
			}}
			{...props}
		>
			<Pre>
				<Code>{props.children}</Code>
			</Pre>
		</PlateElement>
	);
});

const Pre = styled.pre`
	border-radius: 0.375rem;
	font-family: ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
	font-size: 0.875rem; 
	line-height: 1.25rem;
	line-height: 1.5;
	overflow-x: auto;
	padding: 2rem 1.5rem;
`;

const Code = styled.code`

`;

// const ComboboxContainer = styled.div`

// `;

CodeBlockElement.displayName = "CodeBlockElement";
